import { mapState, mapActions } from '/builds/gitlab/gitlab-ee/node_modules/pinia/dist/pinia.mjs?vue3';
import AccessorUtilities from '~/lib/utils/accessor';
import PanelResizer from '~/vue_shared/components/panel_resizer.vue';
import FileBrowserHeight from '~/diffs/components/file_browser_height.vue';
import { useFileTreeBrowserVisibility } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/stores/file_tree_browser_visibility.js?vue3';
import { useMainContainer } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/pinia/global_stores/main_container.js?vue3';
import TreeList from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/file_tree_browser/components/tree_list.vue?vue3';
export const TREE_WIDTH = 320;
export const MIN_TREE_WIDTH = 240;
export const FILE_TREE_BROWSER_STORAGE_KEY = 'file_tree_browser_storage_key';
export default {
    name: 'FileTreeBrowser',
    components: {
        TreeList,
        FileBrowserHeight,
        PanelResizer
    },
    props: {
        projectPath: {
            type: String,
            required: true
        },
        currentRef: {
            type: String,
            required: true
        },
        refType: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            treeWidth: TREE_WIDTH,
            isAnimating: false
        };
    },
    computed: {
        ...mapState(useFileTreeBrowserVisibility, [
            'fileTreeBrowserIsExpanded',
            'fileTreeBrowserIsPeekOn',
            'fileTreeBrowserIsVisible'
        ]),
        ...mapState(useMainContainer, [
            'isCompact'
        ]),
        visibilityClasses () {
            return {
                'file-tree-browser-expanded gl-sticky gl-pb-5': this.fileTreeBrowserIsExpanded,
                'file-tree-browser-peek gl-left-0 gl-pb-9': this.fileTreeBrowserIsPeekOn
            };
        }
    },
    created () {
        this.restoreTreeWidthUserPreference();
    },
    mounted () {
        document.addEventListener('keydown', this.handleEscapeKey);
    },
    beforeDestroy () {
        document.removeEventListener('keydown', this.handleEscapeKey);
    },
    methods: {
        ...mapActions(useFileTreeBrowserVisibility, [
            'resetFileTreeBrowserAllStates'
        ]),
        restoreTreeWidthUserPreference () {
            if (!AccessorUtilities.canUseLocalStorage()) return;
            const userPreference = localStorage.getItem(FILE_TREE_BROWSER_STORAGE_KEY);
            if (!userPreference) return;
            this.treeWidth = parseInt(userPreference, 10);
        },
        onSizeUpdate (value) {
            this.treeWidth = value;
        },
        saveTreeWidthPreference (size) {
            this.treeWidth = size;
            if (!AccessorUtilities.canUseLocalStorage()) return;
            localStorage.setItem(FILE_TREE_BROWSER_STORAGE_KEY, size);
        },
        onOverlayClick () {
            this.resetFileTreeBrowserAllStates();
        },
        handleEscapeKey (event) {
            if (event.key === 'Escape' && this.fileTreeBrowserIsPeekOn) {
                this.resetFileTreeBrowserAllStates();
            }
        }
    },
    fileTreeBrowserStorageKey: FILE_TREE_BROWSER_STORAGE_KEY,
    minTreeWidth: MIN_TREE_WIDTH,
    maxTreeWidth: 500
};
